"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var getExtendedSearchString_1 = __importDefault(require("./getExtendedSearchString"));
var services_1 = require("../../services");
var getFiltersFromLocation_1 = __importDefault(require("./getFiltersFromLocation"));
function extendSearchString(key, value) {
    var history = services_1.getHistory();
    var filters = getFiltersFromLocation_1.default();
    if (!value && !lodash_1.has(filters, key))
        return;
    history.replace(__assign(__assign({}, history.location), { hash: window.location.hash, search: getExtendedSearchString_1.default(key, value) }));
}
exports.default = extendSearchString;
//# sourceMappingURL=extendSearchString.js.map